import React from "react";
import PageTitle from "../assets/images/city-image-navigation.jpeg";
import Layout from "../components/layout/WebLayout";
import TTSForm from "../components/common/TTSForm";
export default function HemenBasvur() {
  const css = `.nice-select.wide .list {
                max-height: 300px;
                overflow-y: scroll !important;
            }`;

  function updateSelectedValues() {
    // Tüm işaretlenmiş checkbox'ları seçiyoruz
    const checkboxes = document.querySelectorAll(
      'input[name="RequestForm.ProductType"]:checked'
    );
    const selectedValues: any[] = [];
    // Seçili checkbox'ların value değerlerini topluyoruz
    checkboxes.forEach((checkbox) => {
      selectedValues.push(checkbox.getAttribute("data-id")); // Değerleri doğrudan alıyoruz
    });
    // Değerleri input alanına yazdırıyoruz
    (document.getElementById("selectedValues") as any).value =
      selectedValues.join(", ");
  }

  return (
    <div className="container-fluid animate pageWrapper">
      <style>
        {css}
        /* Style the input fields */ /* Hide all steps by default: */
      </style>

      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}

        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>HEMEN BAŞVUR</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="#">HEMEN BAŞVUR</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}

        {/* <!--/pageTitle--> */}
        {/* <!--talep-formu--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Text--> */}             
            <TTSForm />
          </div>
        </div>
        {/* <!--/talep-formu--> */}
      </div>

      {/* <script type="text/javascript">
            function updateSelectedValues() {
                // Tüm işaretlenmiş checkbox'ları seçiyoruz
                const checkboxes = document.querySelectorAll('input[name="RequestForm.ProductType"]:checked');
                const selectedValues = [];
                // Seçili checkbox'ların value değerlerini topluyoruz
                checkboxes.forEach((checkbox) => {
                    selectedValues.push(checkbox.getAttribute('data-id')); // Değerleri doğrudan alıyoruz
                });
                // Değerleri input alanına yazdırıyoruz
                document.getElementById('selectedValues').value = selectedValues.join(', ');
            }
        </script> */}
    </div>
  );
}
